export default "__VITE_ASSET__3221e510__"